import RecognizedIcon from '@/shared/assets/icons/recognized.svg?react'
import UnrecognizedIcon from '@/shared/assets/icons/unrecognized.svg?react'

type Props = {
  status: 'recognized' | 'unrecognized'
}

export const MessageStatus = ({ status }: Props) => {
  const baseClasses = {
    recognized: 'text-success text-base',
    unrecognized: 'text-error text-base',
  }[status]

  return (
    <div className="flex items-center gap-2">
      {status === 'recognized' ? <RecognizedIcon /> : <UnrecognizedIcon />}
      <span className={baseClasses}>
        {status === 'recognized' ? 'Распознано' : 'Не распознано'}
      </span>
    </div>
  )
}
